import {
  USER_LOGIN,
  USER_LOGOUT,
  FETCH_USER_LOGIN,
  FETCH_USER_SUCCESS,
  FETCH_USER_ERROR,
} from "../actions/userAction";
const INITIAL_STATE = {
  account: {
    email: "",
    auth: false,
    token: "",
  },
  isLoading: false,
  isError: false,
};

const userReducer = (state = INITIAL_STATE, action) => {
  switch (action.type) {
    case USER_LOGIN:
      return {
        ...state,
        account: {
          auth: true,
        },
      };
    case FETCH_USER_LOGIN:
      return {
        ...state,
        account: {
          auth: false,
        },
        isLoading: true,
        isError: false,
      };
    case FETCH_USER_SUCCESS:
      console.log("User login success:", action);
      return {
        ...state,
        account: {
          auth: true,
          token: action.data.token,
          email: action.data.email,
        },
        isLoading: false,
        isError: false,
      };
    case FETCH_USER_ERROR:
      return {
        ...state,
        account: {
          auth: false,
        },
        isLoading: false,
        isError: true,
      };
    case USER_LOGOUT:
      return {
        ...state,
        account: {
          auth: false,
        },
        isLoading: false,
        isError: false,
      };

    default:
      return state;
  }
};
export default userReducer;
